import styled from "styled-components";
import { theme } from "../../theme";
import { useTranslation } from "react-i18next";
import Small from "./typography/Small";

interface Props {
  tagTitleKey: string;
  variant?: "primary";
  size?: "small" | "medium" | "large";
}

const Container = styled.div<{ $size: "small" | "medium" | "large" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: ${(props) =>
    props.$size === "small"
      ? "2px 2px"
      : props.$size === "medium"
        ? "2px 4px"
        : "4px 12px"};
  border: none;
  display: inline-block;
  height: fit-content;
  width: fit-content;
  background-color: ${theme.colors.primary};
`;

const ChipTag: React.FC<Props> = ({
  tagTitleKey,
  variant = "primary",
  size = "medium",
}) => {
  const { t } = useTranslation();

  if (!tagTitleKey) {
    return null;
  }

  return (
    <Container $size={size}>
      <Small
        color={theme.colors.white}
        fontweight={variant === "primary" ? "normal" : "bold"}
      >
        {t(tagTitleKey)}
      </Small>
    </Container>
  );
};

export default ChipTag;
